import React, { Fragment } from 'react';
import { getSubMenu } from '../utils/menuStatus';
export const SubMenuSection = ({ items }) => {
    if (typeof items === 'undefined') {
        return null;
    }
    return (React.createElement(React.Fragment, null, items.map((item) => item ? React.createElement(Fragment, { key: item.id }, getSubMenu(item.type, item)) : null)));
};
//# sourceMappingURL=index.js.map